import { render } from "./cart.svg?vue&type=template&id=4b25b7ef"
const script = {}

import exportComponent from "/buddy/derek-lam-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__